import BaseComponent from "@js/components/base_component.jsx";

class MuiSeedListsIndex extends BaseComponent {

  render() {
    return (
      <div>
        <p>
          Here is the seed list.
        </p>

        <p>
          <a
            href={ Routes.mui_seed_lists_path({ download: "1" }) }
            // Workaround for issue with Turbolinks showing the progress
            // bar forever when clicking this link.
            onClick={ () => setTimeout(() => Turbolinks.enableProgressBar().done(), 100) }
          >
            Click here
          </a> to download, or copy from the below text box.
        </p>

        <textarea className="form-control seed-list-download" onClick={ this._onClickTextarea }>
          { this.props.seed_list.addresses.join("\n") }
        </textarea>
      </div>
    );
  }

  _onClickTextarea(e) {
    e.target.focus();
    e.target.select();
  }

}

export default MuiSeedListsIndex;
